<template>
    <div id="Shopping">
        <div class="top">
            <p class="topL">欢迎访问畅通圆！</p>
            <div class="topR">
                <el-menu
                    :default-active="activeIndex"
                    class="el-menu-demo fr personal"
                    mode="horizontal"
                    :router="true"
                    @select="handleSelect"
                >
                <el-menu-item index="/doctorInfo" v-if="userInfo.userType==1" >医师注册</el-menu-item>
                <el-menu-item index="/wholesalerInfo" v-if="userInfo.isMerchant==0" >批发商注册</el-menu-item>
                    <!-- <el-menu-item index="/ysRegister" v-if="!isYS">{{ysWords}}</el-menu-item> -->
                    <el-menu-item index="/login" v-if="login">登录</el-menu-item>
                    <el-menu-item index="/register" v-if="login">注册</el-menu-item>

                    <el-submenu index="2" v-if="!login">
                        <template slot="title">
                            <p class="HeadPortrait">
                                <img :src="$store.state.imgUrl+userInfo.headImg" alt />
                            </p>
                            <span>{{userInfo.realName?userInfo.realName:'游客'}}</span>
                        </template>

                        <el-menu-item @click="signOut()">退出</el-menu-item>
                    </el-submenu>
                    <el-submenu index="4" v-if="!login">
                        <template slot="title">我的信息</template>
                        <el-menu-item index="/personalInformation" v-if="!isYS">个人中心</el-menu-item>
                        <el-menu-item index="/personalFiles" v-else>个人中心</el-menu-item>
                        <el-menu-item index @click.native="editPassword">修改密码</el-menu-item>
                    </el-submenu>

                    <el-submenu index="5">
                        <template slot="title">手机版</template>
                        <el-menu-item index="5-1">选项1</el-menu-item>
                    </el-submenu>
                    <el-submenu index="6">
                        <template slot="title">网站导航</template>
                        <el-menu-item index="/index">首页</el-menu-item>
                        <el-menu-item index="/ForumIndex">中医讲堂</el-menu-item>
                        <el-menu-item index="/ancPre">古方大全</el-menu-item>
                        <el-menu-item index="/HerbalMedicineIndex">中草药</el-menu-item>
                        <el-menu-item index="/LibraryIndex">中医文库</el-menu-item>
                        <el-menu-item index="/JingLuoIndex">经络穴位</el-menu-item>
                        <el-menu-item index="/ShopIndex">药城</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
        </div>
        <div class="header2">
            <div class="header2Wrap">
                <div class="header2L">
                    <img src="@/assets/list/logo.png" alt />
                </div>
            </div>
        </div>
        <div class="mainWrap">
            <div class="mainL" v-if="$route.path != '/message'">
                <div class="navs" v-if="!isYS">
                    <h3>个人中心</h3>
                    <ul>
                        <li
                            class="shou"
                            v-for="(item,index) in grList"
                            :key="index"
                            :class="{'active':i1==index}"
                            @click="select(index,item.href)"
                        >{{item.name}}</li>
                    </ul>
                </div>
                <div class="navs" v-if="!isYS">
                    <h3>商城区</h3>
                    <ul>
                        <li
                            class="shou"
                            v-for="(item,index) in scList"
                            :key="index"
                            :class="{'active':i2==index}"
                            @click="select2(index,item.href)"
                        >{{item.name}}</li>
                    </ul>
                </div>
                <div class="navs" v-if="isYS">
                    <h3>医师中心</h3>
                    <ul>
                        <li
                            class="shou"
                            v-for="(item,index) in ysList"
                            :key="index"
                            :class="{'active':i3==index}"
                            @click="select3(index,item.href)"
                        >
                            <span v-if="isYS&&userInfo.approvalStatus =='1'">{{item.name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="mainR">
                <router-view />
            </div>
        </div>

        <div class="foot">
            <p>畅通圆公司版权所有-京ICP备100XXXXX-京公网安备1101080XXXXX01号-京ICP证110XXX号</p>
        </div>
    </div>
</template>

<script>
import vfooter from "@/components/common/Footer";
import topHead from "@/components/common/topHead";
import footerCopy from "@/components/common/footerCopy";
export default {
    name: "Shopping",
    data() {
        return {
            grList: [
                { name: "个人信息", href: "/personalInformation" },
                { name: "我的医案/档案", href: "/myYiAn" },
                { name: "我的收藏", href: "/myCollection" }
            ],
            scList: [
                { name: "我的购物车", href: "/car" },
                { name: "我的订单", href: "/myOrder" },
                // { name: "我的发票", href: "" },
                { name: "我的地址管理", href: "/myAddress" }
            ],
            ysList: [
                { name: "医师个人中心", href: "/personalFiles" },
                { name: "我的患者", href: "/myPatients" }
            ],
            changeRed: 0,
            i1: 0,
            i2: 100,
            i3: 100,
            activeIndex: "1",
            ysWords: "医师注册"
        };
    },
    components: {
        topHead: topHead,
        vfooter: vfooter,
        footerCopy: footerCopy
    },
    created() {
        this.getUserinfo();
        if (sessionStorage.getItem("YS")) {
            this.isYS = JSON.parse(sessionStorage.getItem("YS"));
            if (this.isYS) {
                this.select3(0);
                if (!this.isYS) {
                    this.ysWords = "医师申请";
                }
            }
        } else {
            that.ysWords = "医师注册";
        }
    },
    methods: {
        select(index, href) {
            console.log(href);
            this.i1 = index;
            this.i2 = 100;
            this.i3 = 100;
            this.$router.push({ path: href });
        },
        select2(index, href) {
            this.i1 = 100;
            this.i3 = 100;
            this.i2 = index;
            this.$router.push({ path: href });
        },
        select3(index, href) {
            this.i1 = 100;
            this.i2 = 100;
            this.i3 = index;
            this.$router.push({ path: href });
        },
        handleSelect(index) {
            this.activeIndex = index;
        }
    }
};
</script>
<style scoped>
.top {
    height: 30px;
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    margin: 0px auto;
}
.topL {
    height: 30px;
    line-height: 30px;
    width: 20%;
    float: left;
    letter-spacing: 2px;
    color: #666666;
}
.topR {
    float: right;
    width: 55%;
    height: 30px;
}
.HeadPortrait {
    float: left;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
}
.HeadPortrait img {
    max-width: 100%;
    min-height: 100%;
}

.header2 {
    width: 100%;
    height: 94px;
    background-color: #f64420;
}
.header2Wrap {
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    height: 100%;
    margin: 0px auto;
}
.header2L {
    float: left;
    width: 272px;
    height: 70px;
    margin-top: 12px;
}
.header2L img {
    width: 100%;
    height: 100%;
}
.btmNav {
    width: 100%;
    height: 50px;
    background: #eee;
    border-top: 1px solid #f6f6f6;
    border-bottom: 1px solid #f6f6f6;
    margin-top: 100px;
}
.btmNav ul {
    width: 900px;
    height: 50px;
    margin: 0px auto;
}
.btmNav ul li {
    float: left;
    height: 50px;
    line-height: 50px;
    padding: 0 10px;
    margin: 0 30px;
    font-weight: 600;
    color: #666;
    cursor: pointer;
}
.mainWrap {
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    height: 100%;
    margin: 20px auto;
}
.mainWrap::after {
    content: "";
    display: block;
    clear: both;
    height: 0;
    visibility: hidden;
    overflow: hidden;
}
.mainL {
    float: left;
    width: 160px;
    height: 545px;
    background-color: #ffffff;
    border: solid 1px #dddddd;
}
.navs {
    width: 100%;
}
.navs::after {
    content: "";
    display: block;
    clear: both;
    height: 0;
    visibility: hidden;
    overflow: hidden;
}
.navs h3 {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 23px;
    letter-spacing: 1px;
    color: #333333;
    text-indent: 30px;
    margin-top: 40px;
}
.navs ul {
    width: 100%;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    line-height: 23px;
    letter-spacing: 1px;
    color: #666666;
}
.navs ul li {
    width: 100%;
    text-indent: 30px;
    cursor: pointer;
}
.navs ul li.active {
    color: #f64420;
    border-left: 3px solid #f64420;
}
.mainR {
    float: right;
    width: 82.5%;
    height: 545px;
    overflow-y: auto;
}
/* 底部  */
.foot {
    width: 100%;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    letter-spacing: 1px;
    color: #999999;
    text-align: center;
    border: 1px solid #ddd;
    margin-top: 60px;
}
</style>

<style>
.el-menu.el-menu--horizontal {
    height: 30px;
}
.personal > .el-submenu .el-submenu__title {
    height: 30px !important;
    line-height: 30px !important;
}
.topR .el-menu--horizontal > .el-menu-item {
    height: 30px !important;
    line-height: 30px !important;
}
.el-menu--horizontal > .el-menu-item.is-active,
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    color: #666;
}
#Shopping {
    background: #fbfbfb;
}

.bottomW {
    background-color: #fbfbfb;
}
/* 上方商品分类选项 */
.topList {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ccc;
}
.topList h3 {
    float: left;
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #ffa42f;
    margin: 0;
    cursor: pointer;
    position: relative;
}
.topList-list {
    width: 150px;
    min-height: 350px;
    max-height: 500px;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    z-index: 999;
    overflow-y: auto;
}
.topList-list ul {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px;
}
.topList-list ul li {
    width: 100%;
    height: 35px;
    line-height: 35px;
    color: #fff;
    font-size: 16px;
    font-weight: 100;
    border-bottom: 1px dashed #999;
}
.topList-list ul li span {
    height: 35px;
    line-height: 35px;
    display: block;
    width: 90%;
    float: left;
    text-align: left;
}
.topList-list ul li i {
    height: 35px;
    line-height: 35px;
    display: block;
    width: 10%;
    float: left;
}
.topList .nav {
    float: left;
    width: 80%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    letter-spacing: 1px;
    color: #666666;
}
.topList .nav li {
    float: left;
    padding: 0 10px;
    cursor: pointer;
}
/* 主题内容 */
.main {
    width: 100%;
    margin: 0px auto;
}
.main::after {
    content: "";
    height: 0;
    clear: both;
    overflow: hidden;
    display: block;
    visibility: hidden;
}
/* 商品列表样式 */
.Product1,
.Product2 {
    width: 100%;
}
.Product1::after {
    content: "";
    display: block;
    visibility: hidden;
    height: 0;
    clear: both;
}
.Product2::after {
    content: "";
    display: block;
    visibility: hidden;
    height: 0;
    clear: both;
}
.ProductList {
    float: left;
    width: 24%;
    height: 340px;
    margin: 20px 8px 0 0;
}
.ProductList2 {
    float: left;
    width: 18.7%;
    height: 290px;
    margin: 15px 13px 0 0;
}
.ProductList:nth-child(4n + 4) {
    margin-right: 0;
}
.ProductList2:nth-child(4n + 4) {
    margin-right: 13px;
}
.ProductList2:nth-child(5n + 5) {
    margin-right: 0;
}
.ProductList .ProductImg {
    width: 100%;
    height: 145px;
    overflow: hidden;
    text-align: center;
}
.ProductImg img {
    width: 100%;
    min-height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/OrderList/orderIndex.vue